import React from 'react';
import { motion } from 'framer-motion';
import { Search, X } from 'lucide-react';
import '../Products.css';

const ProductFilters = ({
  categories,
  selectedCategory,
  onCategoryChange,
  searchQuery,
  onSearchChange,
  isFilterOpen,
  setIsFilterOpen,
}) => {
  return (
    <motion.div 
      className="product-filters"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
    >
      <div className="filter-categories">
        {categories.map((category) => (
          <motion.button
            key={category.id}
            className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
            onClick={() => onCategoryChange(category.id)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span className="filter-icon">{category.icon}</span>
            {category.label}
          </motion.button>
        ))}
      </div>

      <div className="filter-search">
        <Search size={18} className="search-icon" />
        <input
          type="text"
          className="search-input"
          placeholder="Search products..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        {searchQuery && (
          <motion.button
            className="search-clear"
            onClick={() => onSearchChange('')}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
          >
            <X size={16} />
          </motion.button>
        )}
      </div>
    </motion.div>
  );
};

export default ProductFilters;